/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { Box, Button, Stack } from '@mui/material'
import { WorkflowStateAction } from '@/types/workflow-state-actions'
import { getDefaultValue, updateParams } from '@/utils/rules'
import { PixyDocsForm } from '../forms'
import ActionParamFields from '../workflow-state-page/ActionParamFields'

type ActionEditFormProps = {
  action: WorkflowStateAction
  onSave: (updatedAction: WorkflowStateAction) => void
  onCancel: () => void
}

export default function ActionEditForm({
  action,
  onSave,
  onCancel,
}: ActionEditFormProps) {
  const defaultValues = useMemo(() => {
    const paramDefaultValues: Record<string, any> = {}
    if (action.action_type?.params_schema.properties) {
      Object.entries(
        action.action_type.params_schema.properties as Record<string, any>,
      ).forEach(([paramName, paramStructure]) => {
        paramDefaultValues[paramName] =
          action.params?.[paramName] ?? getDefaultValue(paramStructure)
      })
    }
    return paramDefaultValues as Record<string, any>
  }, [action])

  const methods = useForm({
    defaultValues,
  })

  const { isValid } = methods.formState

  function onSubmit(data: Record<string, string>) {
    onSave({
      ...action,
      params: updateParams(data, action.action_type?.params_schema.properties),
    })
  }

  return (
    <PixyDocsForm methods={methods} onSubmit={onSubmit}>
      <ActionParamFields action={action} />

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          variant="text"
          onClick={() => {
            onCancel()
          }}
        >
          Cancel
        </Button>
        <Button type="submit" disabled={!isValid}>
          Save
        </Button>
      </Stack>
    </PixyDocsForm>
  )
}
